module.exports = __webpack_public_path__ + "img/restaurantes.22f4e716.png";